<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.code_point"
                  :rules="[rules.required, rules.numeric, rules.codeLength]"
                  label="Código"
                  maxlength="3"
                  placeholder="001"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="8"
              >
                <v-text-field
                  v-model="form.description"
                  :rules="[rules.required]"
                  label="Descripción"
                  placeholder="Punto de Facturación"
                  required
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    components: {
      FormToolbar,
    },
    props: {
      id: { default: '' },
      idSucursal: { default: '' },
      pointId: { default: '' },
    },
    data: () => ({
      form: new Form({
        id: '',
        code_point: '',
        description: '',
        busy: false,
      }),
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        codeLength: (v) => v.length === 3 || 'El campo debe tener de 3 caracteres numéricos.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: '',
      apiURL: '/api/enterprises',
    }),
    computed: {
      ref() { return this.form.id; },
    },
    async mounted() {
      if (this.id) {
        window.axios.get(`${this.apiURL}/${this.id}/subsidiarie/${this.idSucursal}/point/${this.pointId}`)
        .then((result) => {
          Object.assign(this.form, result.data);
          this.URL = `${this.apiURL}/${this.id}/subsidiarie/${this.idSucursal}/point/${this.pointId}/update`;
          this.method = 'PUT';
          this.title = 'Editar Punto de Facturación';
          this.message = `Se ha editado el punto de facturación ${result.data.description} exitosamente.`;
        });
      }
    },

    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        })
        .then(() => {
          this.$router.go(-1);
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
    },
  };

</script>
